<template>
    <vx-expandable-card>
        <template v-slot:content>
            <h3 class="text-xl text-slate-700 font-extrabold">Context</h3>
            <p v-if="onCorporate()" class="text-sm">
                Storage location for local attributes. Email, traceable and custom attributes will match your current
                Voxie context ({{ teamName }} → Corporate) unless group_id is a column in your CSV.
            </p>
            <p v-else class="text-sm">
                Storage location for local attributes. Email, traceable and custom attributes will match your current
                Voxie context ({{ teamName }} → {{ currentGroup?.name }}). A group_id column in your CSV is ignored in
                group context.
            </p>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard } from '@voxie/frontend-components';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const teamName = Spark.state.currentTeam.name;

const { currentGroup, onCorporate } = useCurrentGroup();
</script>
